<template>
  <Popover v-slot="{ close, open }" class="relative">
    <div ref="trigger"><slot name="popoverButton"></slot></div>
    <PopoverButton
      v-if="!$slots.popoverButton"
      id="page-email-builder-template__btn-actions"
      class="max-h-9 border-curious-blue-500 px-2 py-2 leading-5 text-xs inline-flex items-center justify-center rounded transition ease-in-out duration-150 border font-medium text-curious-blue-500 focus:outline-none"
    >
      <div ref="trigger">{{ $t(title) }}</div>
      <UIIcon icon="heroicons-outline:chevron-down" class="w-4 h-4 ml-2" />
    </PopoverButton>

    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0"
      ><teleport to="body"
        ><div v-if="open" ref="container" class="popover-container">
          <div data-popper-arrow class="arrow bg-white shadow-lg"></div>
          <PopoverPanel
            static
            class="w-96 z-10 max-w-sm px-4 mt-1 transform -translate-x-1/4 sm:px-0 lg:max-w-xl"
          >
            <div
              class="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5"
            >
              <div
                class="relative grid gap-3 bg-white lg:grid-cols-1 cursor-pointer py-1"
              >
                <div
                  :id="
                    !(menuItem.id === sepratorId)
                      ? `pg-email-builder-pages-${context}__menu_item-
                        ${menuItem.id}`
                      : ''
                  "
                  v-for="(menuItem, index) in actionMenuItems"
                  :key="menuItem.name"
                  :href="menuItem.href"
                  @click="onActionMenuClick(menuItem, close)"
                  class="flex items-center -m-2 hover:bg-gray-100 transition duration-150 ease-in-out rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                  :class="{
                    'pointer-events-none cursor-none p-0':
                      menuItem.id === sepratorId,
                    'px-4 py-2 ': menuItem.id !== sepratorId,
                    'pt-4': index === 0,
                    'pb-4': index === actionMenuItems.length - 1,
                  }"
                >
                  <template v-if="menuItem.id !== sepratorId">
                    <div
                      class="flex items-center justify-center flex-shrink-0 w-10 h-10 sm:h-12 sm:w-12"
                    >
                      <CustomIcon
                        :iconName="menuItem.icon"
                        className="w-6 h-6 mr-4"
                      />
                    </div>
                    <div>
                      <p class="text-sm font-medium text-gray-800">
                        {{ menuItem.name }}
                      </p>
                      <p class="text-sm text-gray-400">
                        {{ menuItem.description }}
                      </p>
                    </div>
                  </template>
                  <div
                    v-else
                    class="bg-gray-200 border border-gray-200 w-full"
                  ></div>
                </div>
              </div>
            </div>
          </PopoverPanel>
        </div>
      </teleport>
    </transition>
  </Popover>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { UIButton, UIIcon } from '@gohighlevel/ghl-canvas'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import CustomIcon from '../Icons/CustomIcon.vue'
import { usePopper } from '../hooks/use-popper'

export const SEPRATOR_ID = 'seprator'
export default defineComponent({
  components: {
    UIButton,
    Popover,
    PopoverButton,
    PopoverPanel,
    UIIcon,
    CustomIcon,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'emailCampaign.actions',
    },
    actionMenuItems: { type: Object, required: true },
    context: { type: String, required: false, default: '_' },
  },
  setup(props, { emit }) {
    let [trigger, container] = usePopper()

    async function onActionMenuClick(menuItem: any, close: any) {
      close()
      emit('onActionMenuClick', menuItem)
    }
    return { onActionMenuClick, trigger, container, sepratorId: SEPRATOR_ID }
  },
})
</script>

<style scoped></style>
